import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { HOME_ROUTE } from '../../core/constants/routes';
import InfoPage from '../components/info-page/InfoPage';

import Page401Img from '../../../img/401.svg';
import Page403Img from '../../../img/403.svg';
import Page404Img from '../../../img/404.svg';
import Page500Img from '../../../img/500.svg';
import { RootState } from '../../core/state/state';
import { isAzureAccount } from '../../core/utils/isAzureAccount';

interface Props {
  pageType: number;
}

const ErrorPage: React.FC<Props> = ({ pageType = 403 }) => {
  const { t } = useTranslation();
  const projectId = useSelector((state: RootState) => state.user.userInfo?.projectID);

  const getPageData = () => {
    switch (pageType) {
      case 401:
        return {
          title: t('errorPage.401.title'),
          subtitle: t('errorPage.401.description'),
          buttonText: t('common.backToHome'),
          imgSrc: Page401Img
        };
      case 403:
        return {
          title: t('errorPage.403.title'),
          subtitle: t('errorPage.403.description'),
          buttonText: t('common.backToHome'),
          imgSrc: Page403Img
        };
      case 404:
        return {
          title: t('errorPage.404.title'),
          subtitle: t('errorPage.404.description'),
          buttonText: t('common.backToHome'),
          imgSrc: Page404Img
        };
      case 500:
        return {
          title: t('errorPage.500.title'),
          subtitle: t('errorPage.500.description'),
          buttonText: t('common.backToHome'),
          imgSrc: Page500Img
        };
      default:
        return {};
    }
  };

  const data = getPageData();

  return (
    <InfoPage
      title={data.title}
      subtitle={data.subtitle}
      buttonRoute={isAzureAccount ? HOME_ROUTE : `/projects/${projectId}/bookings`}
      buttonText={data.buttonText}
      img={data.imgSrc || ''}
    />
  );
};

export default ErrorPage;
